import React from 'react';
import { motion } from 'framer-motion';

export const FitnessCTA = () => {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      data-testid="fitness-final-cta"
      className="relative bg-black py-24 sm:py-28 px-6 overflow-hidden border-t border-neutral-900"
    >
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[90vw] max-w-[700px] h-[280px] sm:h-[350px] bg-white/5 rounded-full blur-[120px] sm:blur-[140px] pointer-events-none" />
      <div className="container mx-auto max-w-4xl text-center relative z-10">
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-60px' }}
          transition={{ duration: 0.8 }}
          className="font-display text-white text-4xl sm:text-5xl lg:text-6xl uppercase leading-tight"
        >
          Ready to Feel Strong, Lean &amp; Athletic Again?
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-60px' }}
          transition={{ duration: 0.7, delay: 0.15 }}
          className="text-gray-400 text-base sm:text-lg mt-6 max-w-xl mx-auto"
        >
          Start your blueprint with guided coaching built around your real life.
        </motion.p>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-60px' }}
          transition={{ duration: 0.7, delay: 0.3 }}
          className="flex flex-col sm:flex-row gap-4 justify-center mt-10"
        >
          <button
            data-testid="final-cta-view-coaching"
            onClick={() => scrollTo('coaching')}
            className="btn-shine bg-gray-300 hover:bg-white text-black font-bold px-10 py-4 rounded-lg transition-colors"
          >
            <span className="relative z-10">View Coaching Options</span>
          </button>
        </motion.div>
      </div>
    </section>
  );
};
